import Header from '@/src/components/UI/Header/Header';
import { useAppStore } from '@/src/store/global';
import { useEffect, useState } from 'react';
import Footer from '../Footer/Footer';
import styles from './Layout.module.scss';

export default function Layout({ children }: { children: React.ReactNode }) {
    //--------------------------------------
    const [isRefreshing, setIsRefreshing] = useState(true);
    useEffect(() => {
        setIsRefreshing(false);
    }, []);
    //-------------------------------------
    const appStore = useAppStore();
    //--------------------------------------
    return (
        <div className={styles.body}>
            <div className={styles.bg}>
                <div className={styles.red}></div>
                <div className={styles.purple}></div>
            </div>
            <Header />
            {isRefreshing === false && appStore.isAppStoreLoaded === true && <>{children}</>}
            <Footer />
        </div>
    );
}
